import {assignIn, map} from 'lodash'
import router from 'router';
import {getTimeRange} from 'utils/time'
import {getTime} from 'date-fns';

const state = {
  days: 'weekdays',
  ...getTimeRange(30)
};

const actions = {};

const mutations = {
  days (state, value) {
    state.days = value
  },

  timeRange (state, range) {
    router.replace({path: router.path, query: {from: range.from, to: range.to}});
    state.from = range.from;
    state.to = range.to;
  }

};

const getters = {

  timeRange ({from, to}) {
    // default
    if (!from && !to) {
      return getTimeRange(14)
    }

    // now
    if (to === 'now') {
      to = getTime(new Date())
    }

    return {
      from: parseInt(from),
      to: parseInt(to)
    };
  },

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
